import React, {useState,useEffect} from "react";
import { Row, Col,Button } from "react-bootstrap";
import { getAllCountry, getPaymentMethodByCountry, updateCardStatus, updatePMStatus } from "../services/developerApi";
import '../utils/detail.css';
import toast from "react-hot-toast";
import { addCommissionBusiness, getCommissionBusiness, getPaymentMethod, updateCommissionBusiness } from "../../parametre-commission/services/commissionApi";
import { Modal, Spin, Switch } from "antd";
const MehodePaiement= ({  developer}) => {
  const [switchLoading, setSwitchLoading] = useState(false);
  const [openCountry, setOpenCountry] = useState(null);
const [editing, setEditing] = useState({ country: null, developer: null });
const [rates, setRates] = useState({});
        const [countries, setCountries] = useState([]);
        useEffect(() => {
        const fetchCountries = async () => {
        try {
          const response = await getAllCountry();
          setCountries(response || []);
        } catch (error) {
          console.error("Erreur lors du chargement des pays:", 
            error);
        }
      };
      fetchCountries();
    }, []);
    const [openIndexes, setOpenIndexes] = useState([]);
    const toggleOpen = (index) => {
      setOpenIndexes((prev) =>
        prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
      );
    };
    const [commissionsBusiness, setCommissionsBusiness] = useState({});
       const countryFlags = {
  SN: "https://flagcdn.com/w40/sn.png", // Sénégal
  CI: "https://flagcdn.com/w40/ci.png", // Côte d'Ivoire
  BF: "https://flagcdn.com/w40/bf.png", // Burkina Faso
  BJ: "https://flagcdn.com/w40/bj.png", // Bénin
  NE: "https://flagcdn.com/w40/ne.png", // Niger
  ML: "https://flagcdn.com/w40/ml.png", // Mali
  GN: "https://flagcdn.com/w40/gn.png", // Guinée
  TG: "https://flagcdn.com/w40/tg.png", // Togo
  CM: "https://flagcdn.com/w40/cm.png", // Cameroun
  CD: "https://flagcdn.com/w40/cd.png" , // RDC
  KE: "https://flagcdn.com/w40/ke.png", // KE
  NG: "https://flagcdn.com/w40/ng.png",  // ng
  GH: "https://flagcdn.com/w40/gh.png"//gh
};
const countryNames = {
  SN: "Sénégal",
  CI: "Côte d'Ivoire",
  BF: "Burkina Faso",
  BJ: "Bénin",
  NE: "Niger",
  ML: "Mali",
  GN: "Guinée",
  TG: "Togo",
  CM: "Cameroun",
  CD: "RDC",
  KE:"Kenya",
  NG:"Nigerai",
  GH:"Ghana"
};
const [paymentMethodsByCountry, setPaymentMethodsByCountry] = useState({});
 const [defaultPaymentMethods, setDefaultPaymentMethods] = useState({});
const [editingCountryCB, setEditingCountryCB] = useState(null);
const [editingMethodCB, setEditingMethodCB] = useState(null);
const [loadingCommissionBusiness, setLoadingCommissionBusiness] = useState(null);
 const [modalContextCB, setModalContextCB] = useState(null);
 const [isModalOpenCB, setIsModalOpenCB] = useState(false);
 const [selectedCommission, setSelectedCommission] = useState(null);
   const [showDetailModalCB, setShowDetailModalCB] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
const [commissions, setCommissions] = useState([]);

const handleSaveOneLineBusiness = async (businessId, countryCode, updatedMethod) => {
  try {
    const payload = {
      countryCode,
      paymentMethod: updatedMethod.paymentMethod,
      payinCommissionPercentage:
        updatedMethod.paymentMethod === "CARD"
          ? 0
          : Number(updatedMethod.payinCommissionPercentage) ?? 0,
      payoutCommissionPercentage:
        updatedMethod.paymentMethod === "CARD"
          ? 0
          : Number(updatedMethod.payoutCommissionPercentage) ?? 0,
      cardCommissionPercentage:
        updatedMethod.paymentMethod === "CARD"
          ? Number(updatedMethod.cardCommissionPercentage) ?? 0
          : undefined,
    };

    const commissionsForBusiness = commissionsBusiness[businessId] || [];

    let countryData = commissionsForBusiness.find((c) => c.country === countryCode);
    if (!countryData) {
      countryData = { country: countryCode, paymentMethods: [] };
      commissionsForBusiness.push(countryData);
    }

    const existingMethod = countryData.paymentMethods.find(
      (pm) =>
        (pm.paymentMethod || "").trim().toUpperCase() ===
        (payload.paymentMethod || "").trim().toUpperCase()
    );

    if (existingMethod) {
      await updateCommissionBusiness({ businessId, ...payload });
    } else {
      await addCommissionBusiness({ businessId, ...payload });
    }
    toast.success("Commission sauvegardée !");
    setCommissionsBusiness((prev) => {
      const businessComms = prev[businessId] || [];
      const countryIndex = businessComms.findIndex((c) => c.country === countryCode);

      if (countryIndex >= 0) {
        const countryData = businessComms[countryIndex];
        const pmIndex = countryData.paymentMethods.findIndex(
          (pm) => pm.paymentMethod === payload.paymentMethod
        );
        if (pmIndex >= 0) {
          countryData.paymentMethods[pmIndex] = { ...payload };
        } else {
          countryData.paymentMethods.push({ ...payload });
        }
        businessComms[countryIndex] = countryData;
      } else {
        businessComms.push({ country: countryCode, paymentMethods: [{ ...payload }] });
      }
      return { ...prev, [businessId]: businessComms };
    });

    setEditingCountryCB(null);
    setEditingMethodCB(null);
  } catch (error) {
    console.error("❌ Erreur API:", error.response?.data || error.message);
    toast.error("❌ Erreur lors de la sauvegarde !");
  }
};
useEffect(() => {
  const fetchAllPaymentMethods = async () => {
    for (const c of countries) {
      if (!c.countryCode) continue;
      try {
        const methods = await getPaymentMethodByCountry(c.countryCode);
        setPaymentMethodsByCountry((prev) => ({
          ...prev,
          [c.country]: methods || []
        }));
      } catch (error) {
        console.error(`❌ Erreur chargement méthodes pour ${c.country}:`, error);
        setPaymentMethodsByCountry((prev) => ({
          ...prev,
          [c.country]: []
        }));
      }
    }
  };
  fetchAllPaymentMethods();
}, [countries]);

useEffect(() => {
  const fetchCommissions = async () => {
    try {
      const res = await getCommissionBusiness(developer.id);

      console.log("COMPONENT res =", res);

      setCommissionsBusiness({
        [developer.id]: Array.isArray(res) ? res : []
      });

    } catch (err) {
      console.error("Erreur commissions:", err);

      setCommissionsBusiness({
        [developer.id]: []
      });
    }
  };

  if (developer?.id) {
    fetchCommissions();
  }

}, [developer?.id]);

useEffect(() => {
  const fetchDefaultMethods = async () => {
    const allIds = [];

    developer?.countryPaymentMethods?.forEach(country => {
      country.paymentMethods?.forEach(m => {
        if (m.id && !allIds.includes(m.id)) {
          allIds.push(m.id);
        }
      });
    });

    await Promise.all(
      allIds.map(async (id) => {
        if (!defaultPaymentMethods[id]) {
          try {
            const res = await getPaymentMethod(id);

            setDefaultPaymentMethods(prev => ({
              ...prev,
              [id]: res // ✅ IMPORTANT ici
            }));
          } catch (err) {
            console.warn("Erreur default method:", id);
          }
        }
      })
    );
  };

  if (developer?.countryPaymentMethods) {
    fetchDefaultMethods();
  }
}, [developer]);
const [bankEnabled, setBankEnabled] = useState(developer?.bankEnabled);
const handleSwitchChange = async (checked, countryCode, method) => {
  try {
    setSwitchLoading(true);

   if (method.id === "CARD") {
  const payload = checked ? ["BANK_TRANSFER"] : [];

  await updateCardStatus(developer.id, payload);

  setBankEnabled(checked); // 🔥 ICI LA CLÉ

  toast.success(
    checked
      ? "Carte bancaire activée"
      : "Carte bancaire désactivée"
  );
} else {
      const payload = {
        developerAccountId: developer.id,
        country: countryCode,
        paymentMethodId: method.id,
        enabled: checked,
      };

      await updatePMStatus(payload);

    setPaymentMethodsByCountry((prev) => {
  const methods = prev[countryCode] ? [...prev[countryCode]] : [];

  const index = methods.findIndex((m) => m.id === method.id);

  if (index !== -1) {
    methods[index] = {
      ...methods[index],
      status: checked ? "ACTIVE" : "INACTIVE",
    };
  }

  return {
    ...prev,
    [countryCode]: methods,
  };
});

      toast.success(
        checked
          ? "Méthode de paiement  activée"
          : "Méthode de paiement désactivée"
      );
    }
  } catch (err) {
    console.error(err);
    toast.error("Erreur lors de la mise à jour");
  } finally {
    setSwitchLoading(false);
  }
};
useEffect(() => {
  if (!developer?.countryPaymentMethods) return;
  const formatted = {};
  developer.countryPaymentMethods.forEach((country) => {
    formatted[country.country] = country.paymentMethods || [];
  });

  setPaymentMethodsByCountry(formatted);
}, [developer]);
  return (
      <Row className="mt-4 px-3"
              style={{ justifyContent: "center", alignItems: "center", display: "flex",flexDirection: "row",}}>
          
  <Row
    className="mt-4 px-3"
    style={{
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
    }}
  >
    {developer.countryPaymentMethods?.length > 0 ? (
      developer.countryPaymentMethods.map((country, cIndex) => {
        const isOpen = openCountry === country.country;

        return (
          <div
            key={cIndex}
            style={{
              width: "100%",
              marginBottom: "12px",
            }}
          >
            {/* ================= HEADER PAYS ================= */}
            <div
              onClick={() =>
                setOpenCountry((prev) =>
                  prev === country.country ? null : country.country
                )
              }
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                backgroundColor: "#FFFFFF",
                border: "1px solid #0000001A",
                height: "40px",
                overflow: "hidden",
                padding: "0 8px",
                gap: "8px",
                cursor: "pointer",
              }}
            >
              <img
                src={
                  countryFlags[country.country] || "/default-flag.png"
                }
                alt="flag"
                style={{
                  width: "22px",
                  height: "22px",
                  objectFit: "contain",
                }}
              />

              <span
                style={{
                  flex: 1,
                  fontFamily: "Poppins",
                  fontSize: "15px",
                  fontWeight: "400",
                  color: "#000000",
                }}
              >
                {country.name ||
                  countryNames[country.country] ||
                  country.country}
              </span>

              {/* chevron + / - */}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  transform: isOpen
                    ? "rotate(0deg)"
                    : "rotate(0deg)",
                }}
              >
                {isOpen ? "−" : "+"}
              </span>
            </div>

            {/* ================= CONTENT PAYMENTS ================= */}
            {isOpen && (
              <div
                className="responsive-table-wrapper"
                style={{
                  marginBottom: "12px",
                  padding: "6px 8px",
                  backgroundColor: "#fff",
                  border: "1px solid #e0e0e0",
                  width: "100%",
                }}
              >
                {country.paymentMethods?.length > 0 ? (
                  <ul
                    style={{
                      paddingLeft: 0,
                      listStyleType: "none",
                    }}
                  >
                    {country.paymentMethods.map((m, i) => {
                       const methodKey = m.id === "CARD" ? "CARD" : (m.id || m.name);
                      const commissionForCountry =
                        commissionsBusiness[developer.id]?.find(
                          (c) => c.country === country.country
                        );

                      const matchingCommission =
                        commissionForCountry?.paymentMethods?.find(
                          (pm) =>
                            String(pm.paymentMethod).trim() ===
                            String(m.id).trim()
                        );

                      const defaultMethod =
                        defaultPaymentMethods[m.id] || {
                          payInCommission: 0,
                          payOutCommission: 0,
                          cardCommissionPercentage: 0,
                        };

                      const localMethod =
                        paymentMethodsByCountry[
                          country.country
                        ]?.find(
                          (pm) =>
                            (pm.id || pm.name) ===
                            (m.id || m.name)
                        );

                      const isCard = m.id === "CARD";
                      const isEnabled = (m) => {
                        if (m.id === "CARD") return developer?.bankEnabled;
                        return m.status === "ACTIVE";
                      };
                      return (
                        <li
                          key={i}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                             pointerEvents: "auto"
                          }}
                        >
                    <Switch
                    style={{ marginRight: "12px" }}
                    checked={
                      m.id === "CARD"
                        ? bankEnabled
                        : (paymentMethodsByCountry[country.country]?.find(pm => pm.id === m.id)?.status === "ACTIVE")
                    }
                    loading={switchLoading}
                    onChange={(checked) =>
                      handleSwitchChange(checked, country.country, m)
                    }
                  />
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            {isCard ? (
                              <span style={{ fontSize: "31px" }}>
                                💳
                              </span>
                            ) : (
                              <img
                                src={
                                  m?.urlLogo ||
                                  "/default-flag.png"
                                }
                                alt={m?.name}
                                style={{
                                  width: "31px",
                                  height: "31px",
                                  borderRadius: "50%",
                                  objectFit: "contain",
                                }}
                              />
                            )}

                            <span
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "14px",
                                color: "#333",
                              }}
                            >
                              {m?.name}
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "20px",
                              marginLeft: "auto",
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>

                            <label style={{ fontFamily: "Poppins", fontSize: "15px", minWidth: "55px" }}>
                              {m.id === "CARD" ? "Commission carte :" : "PayIn :"}
                            </label>
                            <input
                              type="number"
                              disabled={
                                !(
                                  editingCountryCB === country.country &&
                                  editingMethodCB === methodKey
                                )
                              }
                              value={
                                m.id === "CARD"
                                  ? localMethod?.cardCommissionPercentage ??
                                    commissionForCountry?.cardCommissionPercentage ??
                                    defaultMethod?.cardCommissionPercentage ??
                                    ""
                                  : localMethod?.payinCommissionPercentage ??
                                    matchingCommission?.payinCommissionPercentage ??
                                    defaultMethod?.payInCommission ??
                                    ""
                              }
                              onChange={(e) => {
                                const value = Number(e.target.value);

                                setPaymentMethodsByCountry((prev) => {
                                  const list = [...(prev[country.country] || [])];

                                  const index = list.findIndex(
                                    (pm) => (pm.id || pm.name) === methodKey
                                  );

                                  if (index !== -1) {
                                    list[index] = {
                                      ...list[index],
                                      ...(m.id === "CARD"
                                        ? { cardCommissionPercentage: value }
                                        : { payinCommissionPercentage: value }),
                                    };
                                  } else {
                                    list.push({
                                      id: m.id,
                                      payinCommissionPercentage: m.id === "CARD" ? 0 : value,
                                      payoutCommissionPercentage: 0,
                                      cardCommissionPercentage: m.id === "CARD" ? value : 0,
                                    });
                                  }

                                  return {
                                    ...prev,
                                    [country.country]: list,
                                  };
                                });
                              }}
                              className="form-control"
                              style={{
                                width: "70px",
                                textAlign: "center",
                                backgroundColor:
                                  editingCountryCB === country.country &&
                                  editingMethodCB === methodKey
                                    ? "#FFFFFF"
                                    : "#F5F5F5",
                              }}
                            />

                            <span>%</span>
                          </div>

                            {/* PAYOUT */}
                            {!isCard && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                <label
                                  style={{
                                    fontFamily: "Poppins",
                                    fontSize: "15px",
                                    minWidth: "55px",
                                  }}
                                >
                                  PayOut :
                                </label>

                                <input
                                  type="number"
                                  disabled={
                                !(
                                  editingCountryCB === country.country &&
                                  editingMethodCB === (m.id || m.name)
                                )
                              }
                                                              value={
                                    localMethod?.payoutCommissionPercentage ??
                                    matchingCommission?.payoutCommissionPercentage ??
                                    defaultMethod?.payOutCommission ??
                                    ""
                                  }
                                  onChange={(e) => {
                                    const value = Number(
                                      e.target.value
                                    );

                                    setPaymentMethodsByCountry(
                                      (prev) => {
                                        const list = [
                                          ...(prev[
                                            country.country
                                          ] || []),
                                        ];

                                        const index = list.findIndex(
                                          (pm) =>
                                            (pm.id || pm.name) ===
                                            (m.id || m.name)
                                        );

                                        if (index !== -1) {
                                          list[index] = {
                                            ...list[index],
                                            payoutCommissionPercentage:
                                              value,
                                          };
                                        } else {
                                          list.push({
                                            id: m.id,
                                            payinCommissionPercentage: 0,
                                            payoutCommissionPercentage:
                                              value,
                                          });
                                        }

                                        return {
                                          ...prev,
                                          [country.country]: list,
                                        };
                                      }
                                    );
                                  }}
                                  className="form-control"
                                  style={{
                                    width: "70px",
                                    textAlign: "center",
                                    backgroundColor:
                                  editingCountryCB === country.country &&
                                  editingMethodCB === (m.id || m.name)
                                    ? "#FFFFFF"
                                    : "#F5F5F5"
                                  }}
                                />
                                <span>%</span>
                              </div>
                            )}

                            {/* BUTTON SAVE (TA LOGIQUE) */}
                            <button
                              type="button"
                              disabled={
                            !(
                              editingCountryCB === country.country &&
                              editingMethodCB === (m.id || m.name)
                            )}
                              className="btn btn-primary"
                              onClick={() =>
                                handleSaveOneLineBusiness(
                                  developer.id,
                                  country.country,
                                  {
                                    paymentMethod:
                                      m.id || m.name,
                                    payinCommissionPercentage:
                                      paymentMethodsByCountry[
                                        country.country
                                      ]?.[i]
                                        ?.payinCommissionPercentage ??
                                      matchingCommission?.payinCommissionPercentage ??
                                      defaultMethod?.payInCommission ??
                                      0,
                                    payoutCommissionPercentage:
                                      paymentMethodsByCountry[
                                        country.country
                                      ]?.[i]
                                        ?.payoutCommissionPercentage ??
                                      matchingCommission?.payoutCommissionPercentage ??
                                      defaultMethod?.payOutCommission ??
                                      0,
                                    cardCommissionPercentage:
                                      paymentMethodsByCountry[
                                        country.country
                                      ]?.[i]
                                        ?.cardCommissionPercentage ??
                                      commissionForCountry?.cardCommissionPercentage ??
                                      defaultMethod?.cardCommissionPercentage ??
                                      0,
                                  }
                                )
                              }
                            >
                              Enregistrer
                            </button>
                        <div style={{ display: "flex", justifyContent: "flex-end",marginLeft:"10px" }}>
  <div
  onClick={(e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    e.stopPropagation();
    setModalContextCB({ country: country.country, method: m, index: i }); // stocke infos
    setIsModalOpenCB(true);
    setModalPosition({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX - 100 });
  }}
  style={{
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    cursor: "pointer",
    border: "1px solid #00000014",
  }}
>
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="6" r="2" fill="#21272A" />
    <circle cx="12" cy="12" r="2" fill="#21272A" />
    <circle cx="12" cy="18" r="2" fill="#21272A" />
  </svg>
</div> 
</div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <div style={{ fontStyle: "italic" }}>
                    Aucune méthode disponible
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })
    ) : (
      <div style={{ fontStyle: "italic", color: "#888" }}>
        Aucune méthode disponible
      </div>
    )}
  </Row> 
    <Modal
    open={isModalOpenCB}
    onCancel={() => setIsModalOpenCB(false)}
    footer={null}
    width={180}
    style={{
      background: "#FFFFFF",
      position: "absolute",
      top: modalPosition.top,
      left: modalPosition.left,
      borderRadius: 10,
      border: "1px solid #DFDFDF",
      padding: 0,
      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    }}
    bodyStyle={{ padding: "8px 1px" }}
    mask={false}
    closable={false}
  >
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "12px" }}>
      <a
        onClick={() => {
      if (!modalContextCB) return;

      const { country, method } = modalContextCB;

      setEditingCountryCB(country);
      setEditingMethodCB(method.id || method.name);

      setIsModalOpenCB(false);
    }}
    style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
  >
    <span className="actions">Modifier</span> 
  </a>
      <a
        onClick={() => {
          if (!modalContextCB) return; 
          setSelectedCommission(modalContextCB); 
          setIsModalOpenCB(false);              
          setShowDetailModalCB(true);           
        }}
        style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
      >
        <span className="actions">Simuler modification</span>
      </a>
  
    </div>
  </Modal>

      </Row>
      
      );
};export default MehodePaiement